import mapConfig from '../config/map-config'

const buildSearchSource = (sourceConfig: any, esriLibrary: any) => {
  const { url, ...rest } = sourceConfig
  return {
    locator: new esriLibrary.Locator(url),
    ...rest
  }
}

const buildSearchSources = (sourcesConfig: any[], LocatorConstructor: any) => {
  return sourcesConfig.map(x => buildSearchSource(x, LocatorConstructor))
}

export const buildSearch = (containerId: string, esriLibrary: any, view?: any) => {
  const options = {
    container: containerId,
    sources: buildSearchSources(mapConfig.searchSources, esriLibrary),
    ...mapConfig.searchConfig
  }
  if (view) options.view = view
  return new esriLibrary.Search(options)
}
